// Enchant display helpers. All metadata (scroll/kit item id, product name,
// crafting quality, rarity) arrives resolved in the builds payload —
// Common.EnchantTooltips in the exodia backend owns the enchant-id mappings.
// These helpers only format and default what the payload provides.

// WCL enchant names arrive HTML-escaped, sometimes with a parenthesized
// variant or "Quality" suffix; the payload's enchant_display_name wins when
// the backend resolved one (stat-string enchants like the leg enhancements).
export function formatEnchantName(enchantName, enchantDisplayName) {
  if (enchantDisplayName) return enchantDisplayName;
  if (!enchantName) return enchantName;
  const unescaped = enchantName.replace(/&amp;/g, "&").split(" (")[0];
  const qualityCropIndex = unescaped.indexOf("Quality");
  return qualityCropIndex >= 0 ? unescaped.slice(0, qualityCropIndex) : unescaped;
}

export function getEnchantImgSrc(enchantItemId) {
  return enchantItemId > 0
    ? `https://static.bigbrain.gg/wow/item/assets/${enchantItemId}.webp`
    : "https://static.bigbrain.gg/wow/item/assets/200054.webp";
}

export function getEnchantQualityIconSrc(enchantQuality) {
  return `https://static.bigbrain.gg/wow/icons/item-quality-icons/crafted-item-quality-${enchantQuality ?? 3}.png`;
}
